exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck-content[data-v-f671f1ec]{position:relative;height:100%;overflow:hidden}.ck-content[data-v-f671f1ec] .mask_div{pointer-events:none}.ck-container[data-v-f671f1ec]{font-size:16PX;padding:0 24PX;box-sizing:border-box;height:100%;overflow-y:auto}.ck-container[data-v-f671f1ec] table{word-break:break-all}\n", ""]);

// exports
